import { liquidChart, gaugeChart, radarChart, treeChart, wordChart } from './components';
export default {
  name: 'otherChart',
  components: {
    liquidChart,
    gaugeChart,
    radarChart,
    treeChart,
    wordChart
  },
  data() {
    return {};
  }
};